var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_invoice_act",
          attrs: {
            id: "modal-invoice-act",
            "content-class": "modal-fullscreen",
            "body-class": "modal-body-fullscreen",
            size: "xl",
            title: "Акт",
            "ok-only": false,
            "no-fade": true,
            "ok-title": "Сохранить",
            "ok-variant": "success",
            "cancel-title": "Отменить",
            "button-size": "sm",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          },
          on: { ok: _vm.onOK, cancel: _vm.onCancel, close: _vm.onCancel }
        },
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                { attrs: { "cols-lg": "4", "cols-md": "2", cols: "1" } },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "group-numb",
                            label: "Акт №",
                            "label-for": "input-numb"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input_numb",
                              size: "sm",
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.newItem.numb,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "numb", _vm._n($$v))
                              },
                              expression: "newItem.numb"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "group-date",
                            label: "Дата",
                            "label-for": "input-date"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-date",
                              size: "sm",
                              type: "date"
                            },
                            model: {
                              value: _vm.newItem.date,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "date", $$v)
                              },
                              expression: "newItem.date"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "group-contract",
                            label: "Договор (№ и Дата)",
                            "label-for": "input-contract"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-contract",
                              size: "sm",
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.newItem.contract,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "contract", $$v)
                              },
                              expression: "newItem.contract"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "group-town",
                            label: "Место составления (Город)",
                            "label-for": "input-town"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-town",
                              size: "sm",
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.newItem.town,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "town", $$v)
                              },
                              expression: "newItem.town"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col"),
                  _vm._v(" "),
                  _c("b-col"),
                  _vm._v(" "),
                  _c("b-col")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-card-header",
                [
                  _c(
                    "b-row",
                    { attrs: { "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mr-auto", attrs: { cols: "auto" } },
                        [_c("h5", {}, [_vm._v("Работы")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", variant: "success" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onAddWork()
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v("\n              Добавить\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                ref: "invoice-works",
                staticClass: "mb-0",
                attrs: {
                  id: "invoice-works",
                  selectable: "",
                  "select-mode": "single",
                  selectedVariant: "success",
                  striped: "",
                  small: "",
                  "thead-class": "top-fixed-thead thead-light",
                  "table-class": "text-small",
                  responsive: "",
                  "show-empty": "",
                  "empty-text": _vm.$t("message.common.emptyTable"),
                  items: _vm.newItem.works,
                  fields: _vm.worksFields,
                  "no-provider-filtering": "",
                  "no-provider-paging": "",
                  "no-provider-sorting": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-success my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Загрузка")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(index)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.index + 1) + "\n        "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(work_type_id)",
                    fn: function(row) {
                      return [
                        _c("b-form-select", {
                          attrs: {
                            id: "input_work_type",
                            size: "sm",
                            options: _vm.work_type_catalogs
                          },
                          model: {
                            value: row.item.work_type_id,
                            callback: function($$v) {
                              _vm.$set(row.item, "work_type_id", $$v)
                            },
                            expression: "row.item.work_type_id"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(name)",
                    fn: function(row) {
                      return [
                        _c("b-form-input", {
                          attrs: {
                            id: "input_name",
                            size: "sm",
                            autocomplete: "off"
                          },
                          model: {
                            value: row.item.name,
                            callback: function($$v) {
                              _vm.$set(row.item, "name", $$v)
                            },
                            expression: "row.item.name"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(price)",
                    fn: function(row) {
                      return [
                        _c("b-form-input", {
                          staticClass: "widthPrice",
                          attrs: {
                            id: "input_price",
                            size: "sm",
                            autocomplete: "off"
                          },
                          model: {
                            value: row.item.price,
                            callback: function($$v) {
                              _vm.$set(row.item, "price", _vm._n($$v))
                            },
                            expression: "row.item.price"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(count)",
                    fn: function(row) {
                      return [
                        _c("b-form-input", {
                          staticClass: "widthPrice",
                          attrs: {
                            id: "input_count",
                            size: "sm",
                            autocomplete: "off"
                          },
                          model: {
                            value: row.item.count,
                            callback: function($$v) {
                              _vm.$set(row.item, "count", _vm._n($$v))
                            },
                            expression: "row.item.count"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(nds)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.item.nds) + "%\n        "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(unit)",
                    fn: function(row) {
                      return [
                        _c("unit-select", {
                          ref: "unit_select",
                          attrs: {
                            id: "input_unit",
                            "initial-unit": row.item.unit_code,
                            "is-short": ""
                          },
                          on: {
                            selectUnit: function($event) {
                              return _vm.updateUnit($event, row)
                            }
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(summa)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.priceFormat(row.item.summa)) +
                            "\n        "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(action)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.removeWork(row)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "trash" }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "b-card-footer",
                { attrs: { "footer-bg-variant": "light" } },
                [
                  _c(
                    "b-row",
                    { attrs: { "align-h": "between", "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mr-auto", attrs: { cols: "auto" } },
                        [
                          _vm._v("\n            Всего работ: "),
                          _c("b", [_vm._v(_vm._s(this.newItem.works.length))]),
                          _vm._v(" |\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("b-pagination", {
                            attrs: {
                              id: "invoice-works-pagination",
                              pills: "",
                              "total-rows": this.newItem.works.length,
                              "per-page": _vm.worksPerPage
                            },
                            model: {
                              value: _vm.worksCurrentPage,
                              callback: function($$v) {
                                _vm.worksCurrentPage = $$v
                              },
                              expression: "worksCurrentPage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27e0500e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e0500e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/InvoiceAct.vue
// module id = null
// module chunks = 